import {useEffect, useState} from "react";

/**
 * Подписка на CSS media query.
 * Возвращает true, если запрос совпадает.
 */
const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() => {
        if (typeof window === "undefined" || !window.matchMedia) {
            return false;
        }
        return window.matchMedia(query).matches;
    });

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) {
            return undefined;
        }
        const media = window.matchMedia(query);
        const handler = (event) => setMatches(event.matches);
        setMatches(media.matches);
        media.addEventListener("change", handler);
        return () => media.removeEventListener("change", handler);
    }, [query]);

    return matches;
};

export default useMediaQuery;
